module.exports = __webpack_public_path__ + "img/6.bc58abec.png";